<ion-item id="select-item{{label()}}" button detail="false">
	<ion-label position="stacked">{{ title() }}</ion-label>
	<ion-text>{{ getDisplayText() }}</ion-text>
	<ion-icon slot="end" name="caret-down-outline"></ion-icon>
</ion-item>

<ion-modal trigger="select-item{{label()}}" id="modal_select_item_{{label()}}" (ionModalDidDismiss)="onModalDidDismiss()">
  <ng-template>
@if (allowMulti) {
	<app-ion-multi-search-select [(ngModel)]="selectedValue" [placeholder]="placeholder()" [items]="items()" [displayValue]="displayValue()"
	                         [indexValue]="indexValue()" name="itemMultiSearchSelect"
	                         (selectionCancel)="dismiss()"
	                         (valueChange)="writeValue($event)"
	                         [title]="title()"></app-ion-multi-search-select>
} @else {
	<app-ion-single-search-select [(ngModel)]="selectedValue" [placeholder]="placeholder()" [items]="items()" [displayValue]="displayValue()"
	                          [indexValue]="indexValue()" name="itemSingleSearchSelect"
	                          class="ion-page"
	                          (selectionCancel)="dismiss()"
	                          (valueChange)="onValueChanged($event)"
	                          (selectionConfirm)="dismiss()"
	                          [title]="title()"></app-ion-single-search-select>
}
  </ng-template>
</ion-modal>
